import { Box } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { MultiDayDayBlockItem } from './multi-day-day-block-item';
import { MultiDayDayBlocksSectionProps } from './multi-day-day-blocks-section.types';
import { useMultiDayAccordionState } from './use-multi-day-accordion-state';
import { useMultiDayAutoExpandNewBlock, useMultiDaySync } from '../hooks/use-multi-day-sync';
import { MULTI_DAY_WORK_FORM_FIELDS, MultiDayWorkFormContext } from '../multi-day-work.types';

export const MultiDayDayBlocksSection = ({ breakOptions }: MultiDayDayBlocksSectionProps) => {
  const { control } = useFormContext<MultiDayWorkFormContext>();
  const { deleteBlockAtIndex } = useMultiDaySync();
  const { fields } = useFieldArray({
    control,
    name: MULTI_DAY_WORK_FORM_FIELDS.multiDayDayBlocks,
  });
  const { expandBlock, handleAccordionChange, isExpanded } = useMultiDayAccordionState(
    fields.length
  );

  useMultiDayAutoExpandNewBlock(expandBlock);

  if (fields.length === 0) {
    return null;
  }

  return (
    <Box data-testid="multi-day-day-blocks-section">
      {fields.map((field, index) => (
        <MultiDayDayBlockItem
          breakOptions={breakOptions}
          index={index}
          isEditing={isExpanded(index)}
          key={field.id}
          onCloseEdit={() => handleAccordionChange(index, false)}
          onDelete={() => deleteBlockAtIndex(index)}
          onEdit={() => expandBlock(index)}
        />
      ))}
    </Box>
  );
};
